import i18n from 'app-i18n';
import { isDateRangeValid } from 'components/forms/fields/date-range-field/date-range-field.utils';
import * as yup from 'yup';

// Update throttleSettingsUnique to only check for unique 'orderAmount'
const throttleSettingsUnique = throttleSettings => {
  const orderAmounts = throttleSettings.map(setting => setting.orderAmount);
  const uniqueOrderAmounts = [...new Set(orderAmounts)];
  return orderAmounts.length === uniqueOrderAmounts.length;
};

export const setPreparationTimeFormSchema = yup.object().shape({
  orderType: yup
    .array()
    .of(yup.string())
    .min(1, () =>
      i18n.t('forms.setPreparationTimeForm.fields.orderType.errors.required'),
    ),
  daysOfWeek: yup.array().required().min(1),
  timeRange: yup
    .array()
    .required()
    .test(
      'validTimeRange',
      () =>
        i18n.t(
          'forms.setPreparationTimeForm.fields.timeRange.errors.invalidTimeRange',
        ),
      isDateRangeValid,
    ),
  throttleSettings: yup
    .array()
    .of(
      yup.object().shape({
        orderAmount: yup.number().nullable().required().min(0).max(999999999),
        processingTime: yup
          .number()
          .nullable()
          .required()
          .min(1)
          .max(1439, () =>
            i18n.t(
              'forms.setPreparationTimeForm.fields.throttleSettings.processingTime.errors.max',
            ),
          ),
      }),
    )
    .min(1)
    .required()
    .default([])
    .test(
      'uniqueThrottleSettings',
      () =>
        i18n.t(
          'forms.setPreparationTimeForm.fields.throttleSettings.errors.uniqueOrderAmount',
        ),
      throttleSettingsUnique,
    ),
});
